export enum ReducerActions {
    FETCH_APPLICATION_SETTINGS_FAILED = 'FETCH_APPLICATION_SETTINGS_FAILED',
    FETCH_APPLICATION_SETTINGS_IN_PROGRESS = 'FETCH_APPLICATION_SETTINGS_IN_PROGRESS',
    FETCH_APPLICATION_SETTINGS_SUCCEEDED = 'FETCH_APPLICATION_SETTINGS_SUCCEEDED',
    UPDATE_CONFIGURATION = 'UPDATE_CONFIGURATION',
    FETCH_LANGUAGES_IN_PROGRESS = 'FETCH_LANGUAGES_IN_PROGRESS',
    FETCH_LANGUAGES_SUCCEEDED = 'FETCH_LANGUAGES_SUCCEEDED',
    FETCH_LANGUAGES_FAILED = 'FETCH_LANGUAGES_FAILED',
    FETCH_TRANSLATIONS_FAILED = 'FETCH_TRANSLATIONS_FAILED',
    FETCH_TRANSLATIONS_SUCCEEDED = 'FETCH_TRANSLATIONS_SUCCEEDED',
    FETCH_TRANSLATIONS_IN_PROGRESS = 'FETCH_TRANSLATIONS_IN_PROGRESS',
    FETCH_STARTUP_TOKEN_FAILED = 'FETCH_STARTUP_TOKEN_FAILED',
    FETCH_STARTUP_TOKEN_SUCCEEDED = 'FETCH_STARTUP_TOKEN_SUCCEEDED',
    FETCH_STARTUP_TOKEN_IN_PROGRESS = 'FETCH_STARTUP_TOKEN_IN_PROGRESS',
    LANGUAGE_CHANGE = 'LANGUAGE_CHANGE'
}